import { Injectable } from '@angular/core';
import { BaseApi } from './_base-api';
import { ProductCreate, ProductDetails, ProductEntity, ProductUpdate } from '@repo/types';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ProductApiService extends BaseApi<ProductEntity, ProductCreate, ProductUpdate> {
    constructor() {
        super('Products',
            {
                get: '/AdminPanel/GetProducts',
                post: '/AdminPanel/AddProduct',
            }
        );
    }
    getDetails(id: number) {
        return http$.get<{ product: ProductDetails }>(`/AdminPanel/GetProduct?Id=${id}`);
    }
    override delete<T>(id: number | number[] | { id: number; } | { id: number; }[], opts?: any): any {
        return http$.delete(`/AdminPanel/DeleteProduct`, {
            body: {
                id: id
            }
        });

    }
    updateProduct(model: ProductUpdate) {
        return http$.patch<never>('/AdminPanel/EditProduct', model);
    }
}
